import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { CardTitle } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Col,
  PreviewCard,
  Row,
} from "../components/Component";
import { authHeader } from "../header";
import Content from "../layout/content/Content";
import Head from "../layout/head/Head";
import { updateRights } from "../store/reducers";

export const Homepage = () => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const dispatch = useDispatch();

  const getUserRights = async () => {
    try {
      const { data } = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/rights/user`, {
        headers: authHeader(),
      });
      if (data) {
        // update rights reducer
        dispatch(updateRights(data?.map((right) => right.right)));
      }
    } catch (error) {
    } finally {
    }
  };

  const [admin, setAdmin] = useState()
  const getAdmin = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/auth/admin/users/${userInfo.id}`, {
        headers: authHeader(),
      });
      const resultData = response.data;
      if (resultData) {
        setAdmin(resultData)
        localStorage.setItem("referralCode", JSON.stringify(resultData.myReferralCode));
      }
    } catch (error) {
    }
  };

  useEffect(() => {
    getAdmin();
    getUserRights();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Head title="Homepage"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                Welcome back
              </BlockTitle>
              <BlockDes className="text-soft">
                <p>Welcome to Rosabon Treasury Admin</p>
              </BlockDes>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <Row className="g-gs">
            <Col xxl="6">
              <Row className="g-gs">
                <Col lg="12" xxl="12">
                  <PreviewCard>
                    <div className="card-title-group align-start mb-2">
                      <CardTitle>
                        <h6 className="title">Admin Details</h6>
                      </CardTitle>
                    </div>
                    <div className="align-end gy-3 gx-5">
                      <div className="g-4">
                        <div className="nk-sale-data">
                          <span className="amount">Name</span>
                          <span className="sub-title">{admin?.contactName}</span>
                        </div>
                        <div className="nk-sale-data">
                          <span className="amount">User Group</span>
                          <span className="sub-title">{admin?.assignedRole?.roleName}</span>
                        </div>
                        <div className="nk-sale-data">
                          <span className="amount">Last Login Date</span>
                          <span className="sub-title">{userInfo?.lastLoginDate ?? "N/A"}</span>
                        </div>
                      </div>
                    </div>
                  </PreviewCard>
                </Col>
              </Row>
            </Col>
          </Row>
        </Block>
      </Content>
    </React.Fragment>
  );
};
